module.exports = __webpack_public_path__ + "media/categories/301-9aa0cce5.svg";